import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-lock-toggle',
  standalone: true,
  templateUrl: './lock-toggle.component.html',
  styleUrl: './lock-toggle.component.css',
})
export class LockToggleComponent {
  @Input() unlocked = true;
  @Output() pressed = new EventEmitter<void>();
}
